const PALETTE = ["#2362B4", "#E15554", "#F2A93B", "#3BA55D", "#8E5FD8"];

export const getNotificationColor = (category) => {
  if (!category) return PALETTE[0];
  let hash = 0;
  for (let i = 0; i < category.length; i++) {
    hash = category.charCodeAt(i) + ((hash << 5) - hash);
  }
  return PALETTE[Math.abs(hash) % PALETTE.length];
};

// "WorkOrderAssigned" -> "Work Order Assigned"
export const humanizeCategory = (category) => {
  if (!category) return "";
  return category.replace(/([a-z])([A-Z])/g, "$1 $2");
};
